import { SyntheticEvent, createContext } from "react";
import { DEFAULT_VALUES } from "../variables/checkout_form";

export const CheckOutFormContext = createContext(
    {
        handleFieldChange: (field: string, value: string | number | boolean | undefined) => { },
        internalFormState: DEFAULT_VALUES,
        activateStepsOnFocus: (e: SyntheticEvent, step: string) => { },
    }
);